import axios from "axios";

const CancelToken = axios.CancelToken;
let source = CancelToken.source();

export function post(url, payload = {}) {
    return axios.post(
        url,
        payload,
        {
            cancelToken: source.token
        })
        .then(resp => {
            return resp.data
        })
}

export function get(url, params = {}) {
    return axios.get(
        url,
        {
            params,
            cancelToken: source.token
        })
        .then(resp => {
            return resp.data
        })
}

function cancel() {
    source.cancel()
    source = axios.CancelToken.source()
}

export {cancel}
